export var minHeight = '$_1lTf9';
export var panelWithImageSizing = '$Egnyp';
export var image = '$_29BVX';